<template>
  <Layout>
    <Loader :loading="loading" no-axios>
      <div v-if="(model || {}).id">
        <div class="row g-16px">
          <div class="col-md-12">
            <div class="model-title d-flex align-items-center gap-4">
              <a role="button" @click="$router.back()">
                <i class="mdi mdi-arrow-left"></i>
              </a>
              {{
                model.is_draft ?
                    lodash.startCase($t("unload_drafts.singular")) :
                    lodash.startCase($t("unloads.singular"))
              }}
            </div>
          </div>
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6">
                    <div class="">
                      <div class="row g-0 description-detail" v-if="model.ticketable && model.ticketable.ticket">
                        <div class="col-md-3 label font-size-500">
                          {{ lodash.startCase($t(`${this.resourceRoute}.ticket_id`)) }}
                        </div>
                        <div class="col-md-9 value text-sm">
                          <router-link :to="`/tickets/${model.ticketable.ticket.id}`">{{
                              `${model.ticketable.ticket.id} (${this.$t(`tickets.customer_types.${model.ticketable.ticket.customer_type}`)})`
                            }}
                          </router-link>
                        </div>
                      </div>
                      <div class="row g-0 description-detail" v-else>
                        <div class="col-md-3 label font-size-500">
                          {{ lodash.startCase($t(`${this.resourceRoute}.sales_plan_id`)) }}
                        </div>
                        <div class="col-md-9 value text-sm">
                          <router-link v-if="salesPlan" :to="`/sales_plans/${salesPlan.id}`">
                            {{ salesPlanDisplayName(salesPlan) }}
                          </router-link>
                          <span v-else>-</span>
                        </div>
                      </div>
                      <div class="row g-0 description-detail">
                        <div class="col-md-3 label font-size-500">
                          {{ lodash.startCase($t(`${this.resourceRoute}.trip_id`)) }}
                        </div>
                        <div class="col-md-9 value text-sm">
                          <router-link v-if="model.trip" :to="`/trips/${model.trip.id}`">{{
                              `${model.trip.id}`
                            }}
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6"
                    v-if="!isEditDisabled"
                  >
                    <div class="d-flex justify-content-end gap-8px">
                      <router-link :to="{
                        name: model.is_draft ? 'weight_notes.edit': 'unload.edit',
                        params: { key: model.id }
                      }">
                        <b-button class="border-stroke-neutral" variant="outline-dark">{{
                            lodash.startCase('edit')
                          }}
                        </b-button>
                      </router-link>
                      <router-link v-if="model.is_draft" :to="{
                        name: `unload.edit`,
                        params: { key: model.id }
                      }">
                        <b-button variant="primary">{{
                            lodash.startCase($t('unload_drafts.change_to_unload'))
                          }}
                        </b-button>
                      </router-link>
                    </div>
                  </div>
                </div>
                <hr/>
                <div class="row">
                  <div class="col-md-4">
                    <div class="">
                      <div v-if="model.invoice_number" class="description-detail">
                        <div class="label font-size-500">
                          {{ lodash.startCase($t(`${this.resourceRoute}.invoice_number`)) }}
                        </div>
                        <div class="text-neutral-600">
                          {{ model.invoice_number || "-" }}
                        </div>
                      </div>
                      <div class="description-detail">
                        <div class="label font-size-500">
                          {{ lodash.startCase($t(`${this.resourceRoute}.ordered_at`)) }}
                        </div>
                        <div class="text-neutral-600">
                          {{
                            model.ordered_at
                                ? $moment
                                    .utc(model.ordered_at)
                                    .local()
                                    .format("DD MMMM YYYY")
                                : "-"
                          }}
                        </div>
                      </div>
                      <div class="description-detail">
                        <div class="label font-size-500">
                          {{ lodash.startCase($t(`${this.resourceRoute}.top`)) }}
                        </div>
                        <div class="text-neutral-600">
                          {{ model.duration || 0 }} {{ lodash.startCase($t("units.days")) }} ({{
                            model.ordered_at
                                ? $moment
                                    .utc(model.ordered_at)
                                    .add(this.model.duration || 0, "days")
                                    .local()
                                    .format("DD MMMM YYYY")
                                : "-"
                          }})
                        </div>
                      </div>
                      <div class="description-detail">
                        <div class="label font-size-500">
                          {{ lodash.startCase($t(`${this.resourceRoute}.processing`)) }}
                        </div>
                        <div class="text-neutral-600">
                          {{ model.customer.name }} ({{ model.customer.code }})
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="">
                      <div v-if="model.trip.driver" class="description-detail">
                        <div class="label font-size-500">
                          {{ lodash.startCase($t(`trips.driver`)) }}
                        </div>
                        <div class="text-neutral-600">
                          <span v-if="model.trip.driver">
                            {{ lodash.upperFirst(model.trip.driver.name) }} - {{ model.trip.driver.phone_number }}
                          </span>
                          <span v-else>-</span>
                        </div>
                      </div>
                      <div v-if="model.trip.driver" class="row g-0 description-detail">
                        <div class="label font-size-500">
                          {{ lodash.startCase($t(`trips.vehicle`)) }}
                        </div>
                        <div class="text-neutral-600">
                          {{ lodash.upperFirst(vehicleName) }} - {{ model.trip.vehicle.license_plate }}
                        </div>
                      </div>
                      <div class="row g-0 description-detail">
                        <div class="label font-size-500">
                          {{ lodash.startCase($t(`unloads.fibers`)) }}
                        </div>
                        <div class="text-neutral-600">
                          <span>{{ model.box }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div>
                      <div class="row g-0 description-detail">
                        <div class="col-md-12 font-size-500">
                          {{ lodash.startCase($t(`${this.resourceRoute}.attachment`)) }}
                        </div>
                        <div class="col-md-12 value">
                          <attachment v-if="model.files.length" :files="model.files"></attachment>
                          <span v-else>-</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="card">
              <div class="card-body d-flex flex-column gap-16px">
                <div class="d-flex align-items-center">
                  <div class="section-title flex-grow-1">
                    ITEM NOTA BONGKAR
                  </div>
                </div>
                                <div class="row">
                                  <div class="col-md-12">
                                    <sale-item-table
                                        :is-draft="model.is_draft"
                                        :items="model.sale_items"
                                        :product-type="model.type"
                                        :summaries="model.summaries"
                                    ></sale-item-table>
                                  </div>
                                </div>
                <template v-if="!model.is_draft">
                  <div class="d-flex align-items-center">
                    <div class="section-title flex-grow-1">
                      BIAYA DITANGGUNG JALA
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="rounded overflow-hidden border">
                        <jala-sale-additional-item-table
                            :items="saleAdditionalItemsPaidByJala"
                            :sale-order="model"
                        >
                        </jala-sale-additional-item-table>
                      </div>
                    </div>
                  </div>
                  <template v-if="model.type !== 'harvest'">
                    <div class="d-flex align-items-center">
                      <div class="section-title flex-grow-1">
                        BIAYA DITANGGUNG MITRA
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="rounded overflow-hidden border">
                          <b-table
                              :fields="partnerSaleAdditionalItemsField()"
                              :items="saleAdditionalItemsPaidByPartner"
                              borderless
                              class="striped mb-0"
                          >
                            <template #cell(index)="data">{{ data.index + 1 }}</template>
                          </b-table>
                        </div>
                      </div>
                    </div>
                  </template>
                  <hr/>
                  <div class="row g-0 description-detail">
                    <div class="col-md-12 font-size-500">
                      {{ lodash.startCase($t(`${this.resourceRoute}.additional_fees.margin_in_kg`)) }}
                    </div>
                    <div class="col-md-12 value">
                      {{ $numeral(markupMarginInKg).format("$ 0,0.[00]") }}
                    </div>
                  </div>
                  <div class="row g-0 description-detail">
                    <div class="col-md-12 font-size-500">
                      {{ lodash.startCase($t(`${this.resourceRoute}.total`)) }}
                    </div>
                    <div class="col-md-12 value">
                      {{ $numeral(model.total).format("$ 0,0.[00]") }}
                    </div>
                  </div>
                  <div class="row g-0 description-detail">
                    <div class="col-md-12 font-size-500">
                      {{ lodash.startCase($t(`${this.resourceRoute}.description`)) }}
                    </div>
                    <div class="col-md-12 value">
                      <span v-html="this.model.description || '-'"></span>
                    </div>
                  </div>
                </template>

                <div class="description-detail caption-font-md text-neutral-300">
                  <div class="d-flex gap-2">
                    <div>Dibuat Oleh</div>
                    <div>{{ model.creator.name }}</div>
                  </div>
                  <div class="d-flex gap-2">
                    <div>Dibuat Pada</div>
                    <div>
                      {{
                        $moment
                            .utc(model.created_at)
                            .local()
                            .format("DD MMMM YYYY")
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Loader>
  </Layout>
</template>

<script>
import ModelShow from "../models/show";
import ColumnComponent from "./show/column-component";
import Loader from "@/components/widgets/loader";
import SaleItemTable from "./components/sale-item-table";
import JalaSaleAdditionalItemTable from "@/router/views/unload/components/jala-sale-additional-item-table.vue";
import { salesPlanDisplayName } from "@/helpers/ui/salesPlanLabels";

export default {
  extends: ModelShow,
  page: {
    title: "Detail Nota Bongkar"
  },
  components: {
    Loader,
    JalaSaleAdditionalItemTable,
    SaleItemTable
  },
  props: {
    cardTitle: {
      default() {
        return this.lodash.startCase(this.$t("unloads.singular"));
      }
    },
    resourceRoute: {default: "unloads"},
    modelVariable: {default: "unload"},
    denyEdit: {type: Boolean, default() { return !this.$auth.hasPermissionTo("sale_order.edit") }},
    denyDelete: {type: Boolean, default: true},
    columns: {
      type: Object,
      default() {
        return {
          [this.modelVariable || "model"]: [
            {
              key: "key",
              label: this.$t("models.key"),
              component: ColumnComponent
            }
          ]
        };
      }
    }
  },
  data() {
    return {
      title: this.lodash.startCase(this.$t("unloads.plural"))
    };
  },
  mounted() {
    this.fetchModel();
  },
  computed: {
    saleAdditionalItemsPaidByJala() {
        let defaultPaidByJala = [
          {name: "Diskon", total: 0, disabled: true, paid_by: "jala"},
          {
            name: "Biaya Percepatan",
            total: 0,
            disabled: true,
            paid_by: "jala"
          },
          {
            name: "PPH 22",
            total: 0,
            disabled: true,
            paid_by: "jala",
            options: {show_markup_margin_checkbox: true}
          }
        ];
      let filteredItems = this.model?.sale_additional_items?.filter(item => item.paid_by === "jala") ?? [];

      return filteredItems.length ? filteredItems : defaultPaidByJala;
    },
    saleAdditionalItemsPaidByPartner() {
      let defaultPaidByPartner = [
          {name: "Diskon", total: 0, disabled: true, paid_by: "partner"},
          {name: "Moulting", total: 0, disabled: true, paid_by: "partner"}
        ]
      let filteredItems = this.model?.sale_additional_items?.filter(item => item.paid_by === "partner") ?? [];

      return filteredItems.length ? filteredItems : defaultPaidByPartner;
    },
    markupMarginInKg() {
      return this.model.sale_items[0]?.markup_margin_kg ?? 0
    },
    vehicleName() {
      const vehicle = this.model?.trip?.vehicle;
      if (!vehicle) return '-'
      let label = vehicle?.name

      if (vehicle?.type === 'heavy') label = this.$t('vehicles.truck')
      else if (vehicle?.type === 'medium') label = this.$t('vehicles.crank_truck')
      else if (vehicle?.type === 'light') label = this.$t('vehicles.pickup')

      return label
    },
    items() {
      return [
        {
          text: this.lodash.startCase(this.$t("unloads.plural")),
          href: "/unload"
        },
        {
          text: this.model && this.model.id ? this.model.order_id : this.$route.params.key,
          href: `/unload/${this.$route.params.key}`,
          active: true
        }
      ];
    },
    modelMapped() {
      return this.lodash.isEmpty(this.model) ? [] : [];
    },
    salesPlan() {
      return this.model.sales_plan
    },
    isEditDisabled() {
      if (this.denyEdit === true) {
        return true;
      }
      const isSuperadmin = this.$auth.hasRole('superadmin');
      const isOwner = this.model?.creator?.email === this.$auth?.user()?.email || isSuperadmin;
      return !this.$auth.hasPermissionTo("sale_order.edit") || !isOwner;
    }
  },
  methods: {
    salesPlanDisplayName,
    getModelName() {
      return this.model["order_id"];
    },
    delete() {
      return this.$axios.delete(`/sale_orders/${this.$route.params.key}`);
    },
    fetchModel() {
      this.loading = true;
      return this.$axios.get(`/v2/sale_orders/${this.$route.params.key}`, {
            params: {
              include: [
                "creator",
                "customer",
                "files",
                "sale_additional_items",
                "sale_items.trip_items",
                "sales_plan.product",
                "ticketable.ticket",
                "trip.driver",
                "trip.vehicle",
                "trip.trip_items.purchase_item.purchase_order.purchase_plan",
              ].join(",")
            }
          })
          .then(response => {
            const {
              data: {data}
            } = response;
            this.$set(this, 'model', data);

            return response;
          })
          .catch(error => this.failedAlert(error))
          .finally(() => (this.loading = false));
    },
    partnerSaleAdditionalItemsField() {
      return [
        {
          key: "index",
          label: "No",
          sortable: false,
          style: {width: "1%"}
        },
        {
          key: "name",
          label: `${this.lodash.startCase(this.$t("additional_fees.name"))}`,
          thStyle: {width: "50%"}
        },
        {
          key: "total",
          label: `${this.lodash.startCase(this.$t("additional_fees.total"))}`,
          thClass: "text-end",
          tdClass: "text-end",
          thStyle: {width: "50%"},
          formatter: value => this.$numeral(Math.abs(value)).format("$ 0,0.[00]")
        },
      ]
    },
    jalaSaleAdditionalItemsField() {
      return [
        {
          key: "index",
          label: "No",
          sortable: false,
          style: {width: "1%"}
        },
        {
          key: "name",
          label: `${this.lodash.startCase(this.$t("additional_fees.name"))}`,
          thStyle: {width: "50%"}
        },
        {
          key: "total",
          label: `${this.lodash.startCase(this.$t("additional_fees.total"))}`,
          thClass: "text-end",
          tdClass: "text-end",
          thStyle: {width: "30%"},
          formatter: value => this.$numeral(Math.abs(value)).format("$ 0,0.[00]")
        },
        {
          key: "is_markup_margin_item",
          label: this.lodash.startCase(this.$t('unloads.additional_fees.is_markup_margin_item')),
          style: {width: "20%"},
          formatter: value => this.lodash.upperFirst(value ? this.$t('yes') : this.$t('no')),
        },
        {
          key: "is_markup_margin_item",
          label: this.lodash.startCase(this.$t('unloads.additional_fees.is_markup_margin_item')),
          style: {width: "20%"},
          formatter: value => this.lodash.upperFirst(value ? this.$t('yes') : this.$t('no')),
        },
      ]
    },
  }
};
</script>

<style lang="scss" scoped>
@import "@/design/colors";

.model-title {
  font-family: Lato;
  font-size: 16px;
  font-weight: 800;
  line-height: 20px;
  letter-spacing: 0.05em;
}

.section-title {
  font-family: Lato;
  font-size: 12px;
  font-weight: 800;
  line-height: 14px;
  letter-spacing: 0.05em;
  color: $neutral-300;
}

.description-detail {
  padding: 8px;
}

.card {
  margin-bottom: 0;
}

::v-deep {
  table.striped > tbody > tr:nth-of-type(odd) {
    --bs-table-accent-bg: white;
  }

  table.striped > tbody > tr:nth-of-type(even) {
    --bs-table-accent-bg: #f8fafc;
  }

  thead,
  tfoot {
    tr {
      --bs-table-accent-bg: #f8fafc;
    }
  }
}
</style>
